/**
 * featureFlags: Centralized configuration for LLAP operational feature switches.
 * Controls the temporary direct result delivery pipeline for instructor students.
 */
export const FeatureFlags = {
  DIRECT_INSTRUCTOR_RESULT_RELEASE_ENABLED: process.env.REACT_APP_DIRECT_RELEASE_ENABLED === 'true' || true
};

export default FeatureFlags;